export {
    addDimensions,
    getAnalyticsClickHandler,
    initDimensionsFromState,
    trackAnalyticsEvent,
    trackEventFromState,
    trackEventFromStateOnPageUnload,
    trackInitialPageView,
} from './utils';

export { default as middleware } from './middleware';

export { GA_SETTINGS_PROP_TYPE } from './constants';

export { GA_SETTINGS_PROP_FIXTURE } from './fixtures';

export * from './analyticsModel';
